import React, { useState, useEffect } from 'react'

import notice from './notice.svg'
import './Notice.css'

export const Notice = (props) => {

  const [isMobile, setIsMobile] = useState();
  const [isOpen, setIsOpen] = useState();

  const openClickHandler = (e) => {
    setIsOpen(true);
  }

  const closeClickHandler = (e) => {
    e.stopPropagation();
    setIsOpen(false);
  }

  useEffect(() => {
    const winSize = window.screen.width;
    if(winSize <= 600) {
      setIsMobile(true)
    } else {
      setIsMobile(false)
    }
  }, [])

  return (
    <div className='notice' onClick={isMobile ? openClickHandler : undefined}>
      <div className="notice__content">
        
        { isMobile 
          ? 
            <>
              { isOpen 
                  ? <div className="notice__wrapper--mobile">
                      <button className='notice__close-btn' onClick={closeClickHandler}></button>
                      { props.children }
                    </div> 
                  : null
              }
            </>
            
          : <div className="notice__wrapper--desctop">
              { props.children } 
            </div>
        }
      </div>
      <img className="notice__img" onClick={props.onClick} src={notice} alt=''/>
    </div>
  )
}
